import {combineReducers} from 'redux'
import userReducer from './user/userReducer'

const allReducers = {
    users:userReducer,
}
//合并reducer
const rootReducer = combineReducers(allReducers)

export default rootReducer